import { SkinnableComponent, ComponentSkinProps } from '../../../types/component-skin';
import { COMPONENT_TYPES } from '../../../constants';
import { useBenefitSummaryLogic } from './BenefitSummaryLogic';
import BasicBenefitSummarySkin from './skins/BasicBenefitSummarySkin';

/**
 * BenefitSummary 컴포넌트의 스킨 시스템 정의
 */
export const BenefitSummarySkinnable: SkinnableComponent = {
  type: COMPONENT_TYPES.BENEFIT_SUMMARY,
  name: '혜택 요약',
  category: 'user',
  icon: '📊',
  options: [
    {
      type: 'text',
      label: '제목',
      key: 'title',
      default: '최근 1개월 요약'
    },
    {
      type: 'text',
      label: '빈 상태 메시지',
      key: 'emptyText',
      default: '데이터가 없습니다'
    },
    {
      type: 'checkbox',
      label: '합계 표시',
      key: 'showTotal',
      default: true
    },
    {
      type: 'checkbox',
      label: '날짜 형식 한국어',
      key: 'useKoreanDateFormat',
      default: true
    },
    {
      type: 'number',
      label: '표시 기간 (일)',
      key: 'dateRangeDays',
      default: 30,
      min: 7,
      max: 365
    },
    {
      type: 'color',
      label: '헤더 배경색',
      key: 'headerBackground',
      default: '#f8f9fa'
    },
    {
      type: 'color',
      label: '헤더 텍스트 색상',
      key: 'headerTextColor',
      default: '#495057'
    },
    {
      type: 'color',
      label: '양수 금액 색상',
      key: 'positiveAmountColor',
      default: '#28a745'
    },
    {
      type: 'color',
      label: '음수 금액 색상',
      key: 'negativeAmountColor',
      default: '#dc3545'
    },
    {
      type: 'select',
      label: '테이블 스타일',
      key: 'tableStyle',
      options: [
        { value: 'basic', label: '기본' },
        { value: 'bordered', label: '테두리' },
        { value: 'striped', label: '줄무늬' }
      ],
      default: 'basic'
    }
  ],
  defaultSkin: 'basic',
  internalSkins: {
    basic: BasicBenefitSummarySkin as any
  },
  useLogic: useBenefitSummaryLogic as any,
  defaultProps: {
    title: '최근 1개월 요약',
    emptyText: '데이터가 없습니다',
    showTotal: true,
    useKoreanDateFormat: true,
    dateRangeDays: 30,
    headerBackground: '#f8f9fa',
    headerTextColor: '#495057',
    positiveAmountColor: '#28a745',
    negativeAmountColor: '#dc3545',
    tableStyle: 'basic'
  }
};